import React, {useState} from 'react';
import CustomToolbar from "./toolbar/CustomToolbar";
import Sidebar from "./sidebar/Sidebar";


const Navigation = () => {

    const [sidebarOpen, setSidebarOpen] = useState(false);
    const handleSidebarToggle = () => {
        setSidebarOpen(!sidebarOpen);
    };

    return (
        <>
            <CustomToolbar handleSidebarToggle={handleSidebarToggle} />
            <Sidebar sidebarOpen={sidebarOpen} handleSidebarToggle={handleSidebarToggle}/>
        </>
    );
}

export default Navigation;
